import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import InputSearch from '../../../../../src/web/containers/SMInputSearch';
import style from './SMNearbyAndInput.scss';

const propTypes = {
  isPreview: PropTypes.bool,
  stacked: PropTypes.bool,
  pageType: PropTypes.string,
  widgetId: PropTypes.string,
};

const defaultProps = {
  isPreview: false,
  stacked: false,
  pageType: undefined,
  widgetId: undefined,
};

const SMNearbyAndInput = ({ isPreview, stacked, pageType, widgetId }) => {
  const className = cx(style.column, { [style.fullWidth]: isPreview || stacked });

  return (
    <div className={style.container}>
      <div className={className}>
        <InputSearch pageType={pageType} widgetId={widgetId} />
      </div>
    </div>
  );
};

SMNearbyAndInput.propTypes = propTypes;
SMNearbyAndInput.defaultProps = defaultProps;

export default SMNearbyAndInput;
